<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="back" icon="back" bold :text="lang.button_Back"
            :title="lang.button_Back" :disabled="backButtonStatus"/>
          <!-- <action-button  @click="importing" icon="import" bold :text="lang.button_ImportBom"
            :title="lang.button_ImportBom" :disabled="importButtonStatus"/> -->



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold :text="lang.button_Left"
            :title="lang.button_Left" :disabled="toggleButtonStatus"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold :text="lang.button_Right"
            :title="lang.button_Right" :disabled="toggleButtonStatus"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/ProjectManager/Views/ProjectImportBomLst/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      importButtonStatus: false,
      backButtonStatus: false,
      imported: false,
      //delimiter: ","
    }
  },
  computed:{
    //lengthMapped(){
      
      // if (this.$store.getters.bomDescription.name.length > 0){
      //    this.importButtonStatus = false;
      // }else{
      //    this.importButtonStatus = true;
      // }
      //return this.$store.getters.mappedFields.length;
    //},
    currentRevisionHistory() {
      let revisionId = "";
      for (let i = 0, lei = this.$store.getters.revisionHistory.length; i < lei; i++){
        if (this.$store.getters.revisionHistory[i].status.display == "pending") {
          revisionId = this.$store.getters.revisionHistory[i].id;
          break;
        }

      }
      return revisionId;
    },
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    

  },
  created() {

    //this.importButtonStatus = true;
  },
  watch: {
    // lengthMapped: function(newVal, oldVal){
      
    //   if (newVal > 0){
    //      this.importButtonStatus = false;
    //   }else{
    //      this.importButtonStatus = true;
    //   }
     
    // }

  },
  methods: {
    // setSeparator(delimiter){
      
    //   this.delimiter = delimiter;
    // },
    importing(){
      

      let _vue = this;
   

      var obj = {
        projectRvisionId: this.lastRevisionHistory.id,
         
        }

      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      this.$store.dispatch(this.$store.getters.sectionPrefix+"_importBomLst", obj)
        .then(function(result){

          console.log(result)

          

          if (result.status == "OK"){

            _vue.imported = true;

            let obj = {
              text: _vue.lang.alert_success_import,
              time: 5,
              type: "success"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)

            //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_resetMapField");

            const reloadObj = {
                status: true,
                name: "BomsProjectTableComponent"
            }
            _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);


            _vue.back();

          }else{

            let obj = {
              text: _vue.lang.alert_error_import + " Error: " + result.message,
              time: 10,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }


      })
      .then(function() {
        
        _vue.$store.dispatch("showLoader", {visible: false});
        
      })



    },
    back(){


      let to = this.$route.query.from;


      

      const query = {
        from: this.$route.path,
        to: to,
        projectId: this.$route.query.projectId
      }

      this.$router.push({ path: to, query: query });

    },
    toggleRightPanel(){
      console.log(this.$parent.isVisibleRight)
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      console.log(this.$parent.isVisibleRight)
    },
    toggleLeftPanel(){
      console.log(this.$parent.isVisibleLeft)
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      console.log(this.$parentisVisibleLeft)
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectImportBomLst/Middle/Middle.vue